import { Link } from "react-router-dom";

const SIZES = {
  sm: "h-12 w-12",             // header / footer top
  md: "h-24 w-24",            // landing / auth / footer main
  lg: "h-40 w-40 md:h-56 md:w-56", // hero
};

export function Logo({ size = "md" }) {
  return (
    <Link to="/" className="inline-flex items-center justify-center select-none" aria-label="LUXE ORYVEA PREMIUM — accueil" data-testid="brand-logo">
      <img
        src="/assets/logo-oryvea.webp"
        alt="LUXE ORYVEA PREMIUM"
        className={`${SIZES[size] || SIZES.md} object-contain rounded-full`}
        draggable="false"
        loading={size === "sm" ? "eager" : "lazy"}
      />
    </Link>
  );
}
